import { ReactNode } from 'react';

interface PaginatedContentProps {
  loading?: boolean;
  searched: boolean;
  hasResults: boolean;
  emptyMessage?: string;
  noResultsMessage?: string;
  loadingMessage?: string;
  onClearFilters?: () => void;
  children: ReactNode;
}

/**
 * Wrapper padrão de listagens paginadas: estados de carregando / vazio /
 * sem resultados, sempre mantendo o conteúdo montado (com overlay de loading).
 */
export default function PaginatedContent({
  loading = false,
  searched,
  hasResults,
  emptyMessage = 'Nada por aqui ainda',
  noResultsMessage = 'Nenhum resultado encontrado',
  loadingMessage = 'Carregando...',
  onClearFilters,
  children,
}: PaginatedContentProps) {
  if (!searched) {
    return (
      <div className="card text-center py-10">
        <p className="text-gray-400">{emptyMessage}</p>
      </div>
    );
  }

  if (searched && !hasResults) {
    return (
      <div className="card text-center py-10">
        <p className="text-gray-400">{noResultsMessage}</p>
        {onClearFilters && (
          <button onClick={onClearFilters} className="btn-secondary text-sm mt-3">
            Limpar filtros
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="relative">
      {children}
      {loading && (
        <div className="absolute inset-0 bg-gray-950/50 rounded-xl flex items-center justify-center z-10">
          <p className="text-sm text-gray-300 bg-gray-800/90 px-4 py-2 rounded-lg">
            {loadingMessage}
          </p>
        </div>
      )}
    </div>
  );
}